import Vue from 'vue'
import { Table, TableColumn, Pagination, Input, Button } from '@atsfe/qaxd'

Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Input)
Vue.use(Button)
